export const queryParamsToString = (queryParams: any) => {
  const esc = encodeURIComponent

  return Object.keys(queryParams)
    .map((key) => `${esc(key)}=${esc(queryParams[key])}`)
    .join('&')
}
